/**
 * JOB web
 */


const web = {
    // 前台电子简历相关
    createResume: "/api/User/resume", // 创建简历
    getResumeDetails: "/api/Resume/details/", // 
    delResume: "/api/Resume/del/", //

    //上传图片
    editorUploadImage: "/api/File/upload", // 图片上传接口；
    UploadFileResume: "/api/User/import", // 简历上传接口；
    

    //岗位分类
    getJobTypeList: '/web/Type/list', // 岗位分类列表
    jobTypeSave: '/web/Type/add', // 岗位分类列表 新增
    jobTypeUpdate: '/web/Type/edit', // 岗位分类列表 编辑
    jobTypeDelete: '/web/Type/del/', // 岗位分类列表 删除



    // 应聘人员
    getJoinPeopleList: "/web/User/list", // 求职者列表
    joinPeopleListSave: "/web/User/add", // 求职人员添加
    joinPeopleListUpdate: '/web/User/edit', // 求职人员 编辑
    joinPeopleListDelete: '/web/User/del/', // 求职人员 删除

    // 简历管理
    getResumeCollectionList: "/web/Resume/list", // 电子简历 详情
    getResumeCollectionDetails: "/web/Resume/details/", // 电子简历 详情
    resumeCollectionSave: "/web/User/Resume", // 电子简历 保存


    // 岗位-简历
    getJobAndPeopleList: "/web/Resume/delivery",
}

export default web;
